import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import type { SelectOption } from "./SelectField";
import clsx from "clsx";

interface OptionItemProps {
  option: SelectOption;
  selected: boolean;
  highlighted: boolean;
  onClick: (value: string) => void;
  onMouseEnter: () => void;
  optionClassName?: string;
  style?: React.CSSProperties;
}

const OptionItem: React.FC<OptionItemProps> = ({
  option,
  selected,
  highlighted,
  onClick,
  onMouseEnter,
  optionClassName,
  style,
}) => (
  <li
    style={style}
    id={`option-${option.value}`}
    className={clsx(
      "px-5 py-2 text-base cursor-pointer rounded transition-colors select-none flex items-center justify-between",
      selected && "bg-[#2564cf] text-white",
      highlighted && !selected && "bg-[#e8f0fe] text-[#2564cf]",
      option.disabled && "text-gray-400 cursor-not-allowed bg-transparent",
      optionClassName
    )}
    onClick={e => {
      if (option.disabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      onClick(option.value);
    }}
    role="option"
    aria-selected={selected}
    aria-disabled={option.disabled}
    tabIndex={option.disabled ? -1 : 0}
    onMouseEnter={option.disabled ? undefined : onMouseEnter}
    aria-label={option.label}
  >
    <span>{option.label}</span>
    {selected && <FaCheckCircle className="ml-2 text-[#107c10]" />}
  </li>
);

export default OptionItem;